import { render } from "./DashboardPie.vue?vue&type=template&id=e7eda4d2"
import script from "./DashboardPie.vue?vue&type=script&lang=js"
export * from "./DashboardPie.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__